import { Controller } from "@hotwired/stimulus"
import envatoSso from "../utils/envatoSsoInstance"

import SessionManager from "../utils/session_manager"
import Recaptcha from "../utils/recaptcha"
import ssoRedirects from "../utils/sso_redirects"

export default class extends Controller {
  static targets = [
    "form",
    "username",
    "password",
    "error",
    "errorMessage",
    "recaptchaWidget",
    "twoFactor",
    "authenticationCode",
    "emailConfirmationRequired",
    "passwordResetRequired",
    "modal",
    "usernameWrapper",
    "passwordWrapper",
  ]

  static classes = ["inputError", "loading"]

  connect() {
    envatoSso.configure({
      serverHost: this.ssoServerDomain,
    })
    this.sessionManager = new SessionManager({
      envatoSso: envatoSso,
      clientSlug: this.ssoClientKey,
      ui: this,
    })
    this.recaptcha = new Recaptcha("recaptcha-widget", this.recaptchaWidgetTarget)
    this.sessionManager.autoSignIn()
    this.usernameTarget.focus()
  }

  submit(event) {
    event.preventDefault()
    this.clearError()
    if (this.validateForm()) {
      this.sessionManager.signIn()
    }
  }

  validateForm() {
    const usernameValid = this.validateUsername()
    const passwordValid = this.validatePassword()
    return usernameValid && passwordValid
  }

  validateUsername() {
    if (this.usernameTarget.value === "") {
      this.usernameWrapperTarget.classList.add(this.inputErrorClass)
      return false
    } else {
      this.usernameWrapperTarget.classList.remove(this.inputErrorClass)
      return true
    }
  }

  validatePassword() {
    if (this.passwordTarget.value === "") {
      this.passwordWrapperTarget.classList.add(this.inputErrorClass)
      return false
    } else {
      this.passwordWrapperTarget.classList.remove(this.inputErrorClass)
      return true
    }
  }

  displayError(message) {
    this.errorMessageTarget.innerHTML = message
    this.errorTarget.style.display = "block"
  }

  clearError() {
    this.errorMessageTarget.innerHTML = ""
    this.errorTarget.style.display = "none"
    this.usernameWrapperTarget.classList.remove(this.inputErrorClass)
    this.passwordWrapperTarget.classList.remove(this.inputErrorClass)
  }

  resetRecaptcha() {
    this.recaptcha.reset()
  }

  showRecaptcha() {
    this.recaptcha.show()
  }

  hideRecaptcha() {
    this.recaptcha.hide()
  }

  getRecaptchaData() {
    const data = this.recaptcha.data()
    return data
  }

  getSignInData() {
    const username = this.usernameTarget.value
    const password = this.passwordTarget.value
    return {
      username: username,
      password: password,
    }
  }

  hideTwoFactor() {
    this.twoFactorTarget.style.display = "none"
  }

  showTwoFactor() {
    this.twoFactorTarget.style.display = "block"
    this.authenticationCodeTarget.focus()
  }

  getTwoFactorData() {
    const authenticationCode = this.authenticationCodeTarget.value
    return { authentication_code: authenticationCode }
  }

  clearTwoFactor() {
    this.authenticationCodeTarget.value = ""
  }

  showVerificationForm(token) {
    // Not implemented on-site yet. Redirect to SSO instead.
    ssoRedirects.signInVerification(this.ssoServerDomain, token, this.ssoClientKey)
  }

  showEmailConfirmation() {
    this.hideLoginForm()
    this.emailConfirmationRequiredTarget.style.display = "block"
  }

  showForcedPasswordReset() {
    this.hideLoginForm()
    this.passwordResetRequiredTarget.style.display = "block"
  }

  showLoginForm() {
    this.modalTarget.classList.remove(this.loadingClass)
    this.formTarget.style.display = "block"
  }

  hideLoginForm() {
    this.formTarget.style.display = "none"
  }

  get ssoServerDomain() {
    return document.head.querySelector('meta[name="sso_server_domain"]').content
  }

  get ssoClientKey() {
    return document.head.querySelector('meta[name="sso_client_key"]').content
  }
}
